(function () {
  var menuButton = document.querySelector("[data-menu-toggle]");
  var menu = document.querySelector("[data-mobile-menu]");
  if (menuButton && menu) {
    menuButton.addEventListener("click", function () {
      var open = menu.classList.toggle("is-open");
      menuButton.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  document.addEventListener("click", function (event) {
    var qtyBtn = event.target.closest("[data-qty]");
    if (!qtyBtn) return;
    var wrap = qtyBtn.closest(".pv-qty");
    if (!wrap) return;
    var input = wrap.querySelector("input[name='quantity']");
    if (!input) return;
    var next = parseInt(input.value, 10) || 1;
    next += qtyBtn.getAttribute("data-qty") === "minus" ? -1 : 1;
    input.value = Math.max(1, Math.min(99, next));
  });

  function drawer() {
    return document.querySelector("[data-cart-drawer]");
  }

  function setOpen(open) {
    var root = drawer();
    if (!root) return;
    root.classList.toggle("is-open", open);
    document.body.style.overflow = open ? "hidden" : "";
    if (open) {
      var close = root.querySelector("[data-drawer-close]");
      if (close) close.focus();
    }
  }

  document.addEventListener("click", function (event) {
    if (event.target.closest("[data-cart-open]")) {
      event.preventDefault();
      setOpen(true);
    }
    if (event.target.closest("[data-drawer-close]")) {
      setOpen(false);
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") setOpen(false);
  });

  function refreshDrawer(openAfter) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    return fetch(root + "?sections=cart-drawer")
      .then(function (response) { return response.json(); })
      .then(function (data) {
        var html = data["cart-drawer"];
        if (!html) return;
        var current = document.getElementById("shopify-section-cart-drawer");
        if (!current) return;
        var parsed = new DOMParser().parseFromString(html, "text/html");
        var next = parsed.querySelector("#shopify-section-cart-drawer");
        current.innerHTML = next ? next.innerHTML : html;
        var count = current.querySelector("[data-cart-count]");
        document.querySelectorAll("[data-cart-count-bubble]").forEach(function (node) {
          if (!count) return;
          node.textContent = count.getAttribute("data-cart-count");
          node.hidden = count.getAttribute("data-cart-count") === "0";
        });
        if (openAfter) setOpen(true);
      });
  }

  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.querySelector("[data-add-ajax]")) return;
    var submitter = event.submitter;
    if (!submitter || !submitter.hasAttribute("data-add-ajax")) return;
    event.preventDefault();
    submitter.disabled = true;
    var body = new FormData(form);
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || "/") + "cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: body
    })
      .then(function (response) {
        if (!response.ok) throw new Error("cart");
        return refreshDrawer(true);
      })
      .catch(function () { form.submit(); })
      .finally(function () { submitter.disabled = false; });
  });

  var track = document.querySelector("[data-track-form]");
  if (track) {
    track.addEventListener("submit", function (event) {
      event.preventDefault();
      var input = track.querySelector("input[name='tracking']");
      var value = (input && input.value || "").trim();
      var error = track.querySelector("[data-track-error]");
      if (!value) {
        if (error) error.hidden = false;
        return;
      }
      if (error) error.hidden = true;
      var base = track.getAttribute("data-track-url") || "";
      var url = base.indexOf("CODE") >= 0 ? base.replace("CODE", encodeURIComponent(value)) : base + encodeURIComponent(value);
      window.open(url, "_blank", "noopener");
    });
  }

  document.addEventListener("click", function (event) {
    var thumb = event.target.closest("[data-thumb]");
    if (!thumb) return;
    var main = document.querySelector("[data-gallery-main]");
    if (!main) return;
    main.src = thumb.getAttribute("data-thumb");
    main.alt = thumb.getAttribute("data-alt") || main.alt;
  });
})();

/* Smooth momentum scroll — same effect as RZMARKET (script.js) */
(function smoothScroll() {
  if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
  if ("ontouchstart" in window) return;

  var current = window.scrollY;
  var target = window.scrollY;
  var rafId = null;
  var ease = 0.08;

  function lerp(start, end, t) {
    return start + (end - start) * t;
  }

  function update() {
    current = lerp(current, target, ease);
    if (Math.abs(current - target) < 0.5) {
      current = target;
      window.scrollTo(0, current);
      rafId = null;
      return;
    }
    window.scrollTo(0, current);
    rafId = requestAnimationFrame(update);
  }

  window.addEventListener("wheel", function (e) {
    var cart = document.querySelector("[data-cart-drawer]");
    if (cart && cart.classList.contains("is-open")) return;
    if (document.body.style.overflow === "hidden") return;

    var el = e.target;
    while (el && el !== document.body && el !== document.documentElement) {
      var ov = getComputedStyle(el).overflowY;
      if ((ov === "auto" || ov === "scroll") && el.scrollHeight > el.clientHeight) return;
      el = el.parentElement;
    }
    e.preventDefault();
    target = Math.max(
      0,
      Math.min(document.documentElement.scrollHeight - window.innerHeight, target + e.deltaY)
    );
    if (!rafId) rafId = requestAnimationFrame(update);
  }, { passive: false });

  window.addEventListener("scroll", function () {
    if (!rafId) {
      current = window.scrollY;
      target = window.scrollY;
    }
  });

  window.addEventListener("resize", function () {
    current = window.scrollY;
    target = window.scrollY;
  });
})();
